import React from "react"
import { Router } from "@reach/router"

import VialogPlugin from '../components/VialogPlugin'

const HostedPlugin = ()=>{
	return (
		<div>
			<Router>
				{/* <Redirect from="/host/*" to="/" /> */}
				<VialogPlugin path="/:shortcode" />
			</Router>
		</div>
	)
}



export default HostedPlugin